var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-top-nav"},[_c('img',{attrs:{"src":require("./../assets/previous.png")},on:{"click":_vm.back}}),_c('h3',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }